export default __webpack_public_path__ + "static/media/hackerrank.03969e61.webp";